module.exports = __webpack_public_path__ + "img/KCC.afc0489e.svg";